import { useState } from 'react';

export type ActionResult = { text: string; isError: boolean } | null;

/**
 * Track a busy flag and success/error message for an async user action.
 *
 * @returns The busy flag, last result and a runner.
 */
export const useAction = () => {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState<ActionResult>(null);

  const run = async (action: () => Promise<string>, successPrefix: string) => {
    setBusy(true);
    setResult(null);
    try {
      const outcome = await action();
      setResult({ text: `${successPrefix}${outcome}`, isError: false });
    } catch (error) {
      setResult({
        text: error instanceof Error ? error.message : String(error),
        isError: true,
      });
    } finally {
      setBusy(false);
    }
  };

  const reset = () => setResult(null);

  return { busy, result, run, reset };
};
